import { CopyEmailButton } from "@/components/common/copy-email-button";
import {
  CONTACT_EMAIL,
  CONTACT_HOURS,
  CONTACT_PHONE,
} from "@/constants/contact";
import { Popover, PopoverContent, PopoverTrigger } from "@/styles/ui/popover";
import { logContactOpen } from "@/utils/usage-log";
import { ChevronRight, Mail, Phone } from "lucide-react";

/**
 * 홈 LSB 하단 "문의하기" 플라이아웃 메뉴.
 * 위치/크기는 Figma(6826:627949) 절대좌표에 맞춘 값이다.
 */
// TODO(홈 개편): toggle-ui-kit 에 Popover 가 생기면 이관한다 (@/styles/ui 는 deprecated)
export const ContactFlyout = () => {
  return (
    <Popover onOpenChange={(open) => open && logContactOpen()}>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="flex items-center gap-2 rounded-lg px-2 py-1.5 text-left hover:bg-line-neutral data-[state=open]:bg-line-neutral"
        >
          <span className="flex-1 label-1-normal-medium text-label-neutral">
            문의하기
          </span>
          <ChevronRight className="size-3.5 shrink-0 text-label-neutral" />
        </button>
      </PopoverTrigger>
      <PopoverContent
        className="flex w-[264px] flex-col gap-1 rounded-2xl border-neutral-200 px-0 pb-3 pt-2 shadow-xlarge"
        side="right"
        align="end"
        sideOffset={-8}
        alignOffset={19}
      >
        <div className="flex flex-col gap-0.5 px-4 py-2">
          <p className="truncate body-2-normal-semibold text-label-normal">
            문의하기
          </p>
          <p className="truncate caption-1-medium text-label-alternative">
            운영시간: {CONTACT_HOURS}
          </p>
        </div>
        <div className="h-px w-full shrink-0 bg-line-normal" />
        <div className="flex flex-col">
          <div className="flex items-center gap-2 px-4 py-2">
            <div className="flex items-center rounded-md bg-gray-100 p-1.5">
              <Phone className="size-4 text-label-normal" />
            </div>
            <div className="flex min-w-0 flex-1 flex-col">
              <span className="caption-1-regular text-label-alternative">
                유선 전화
              </span>
              <span className="truncate label-2-medium text-label-normal">
                {CONTACT_PHONE}
              </span>
            </div>
          </div>
          <div className="flex items-center gap-2 px-4 py-2">
            <div className="flex items-center rounded-md bg-gray-100 p-1.5">
              <Mail className="size-4 text-label-normal" />
            </div>
            <div className="flex min-w-0 flex-1 flex-col">
              <span className="caption-1-regular text-label-alternative">
                이메일 문의
              </span>
              <div className="flex items-center gap-1">
                <a
                  href={`mailto:${CONTACT_EMAIL}`}
                  className="min-w-0 flex-1 truncate label-2-medium text-label-normal underline"
                >
                  {CONTACT_EMAIL}
                </a>
                <CopyEmailButton className="text-label-alternative" />
              </div>
            </div>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};
